import { useEffect, useState } from 'react'
import { lotteryService } from '../services/lotteryService'

export function useLotteryCountdown(betEndTime?: string | null, fallback: string = '24 ชั่วโมง'): string {
  const [countdown, setCountdown] = useState(() => (
    betEndTime ? lotteryService.formatTimeRemaining(betEndTime) : fallback
  ))

  useEffect(() => {
    if (!betEndTime) {
      setCountdown(fallback)
      return
    }

    const update = () => setCountdown(lotteryService.formatTimeRemaining(betEndTime))
    update()

    const intervalId = window.setInterval(update, 1000)
    return () => window.clearInterval(intervalId)
  }, [betEndTime, fallback])

  return countdown
}
